module.exports = __webpack_public_path__ + "img/screenshot-2.27d7f5c0.png";